import { Maybe } from '@passionware/monads';
import { ReactElement } from 'react';
import { cn } from 'v5/platform/dom/cn';

export interface SplitButtonLayoutProps {
  leftSlot: ReactElement;
  rightSlot: Maybe<ReactElement>;
  className?: string;
}

export function SplitButtonLayout(props: SplitButtonLayoutProps) {
  if (!props.rightSlot) {
    return props.leftSlot;
  }
  return (
    <div
      className={cn(
        'flex flex-row *:first:rounded-r-none *:last:border-l-black/10 *:last:rounded-l-none *:first:z-10 isolate',
        props.className
      )}
    >
      {props.leftSlot}
      {props.rightSlot}
    </div>
  );
}
